import { lazy } from 'react';

const RecipientsPage = lazy(() =>
  import('../../components/pages/Mailing/RecipientsPage'),
);
const GroupsPage = lazy(() =>
  import('../../components/pages/Mailing/GroupsPage'),
);
const GroupDetailsPage = lazy(() =>
  import('../../components/pages/Mailing/GroupDetailPage'),
);

export const mailingRoutes = [
  {
    path: '/odbiorcy',
    permission: 'mailing.view',
    access: 'authenticated',
    roles: ['ADMIN', 'LABO'],
    Component: RecipientsPage,
  },
  {
    path: '/mailing-group',
    permission: 'mailing.view',
    access: 'authenticated',
    roles: ['ADMIN', 'LABO'],
    Component: GroupsPage,
  },
  {
    path: '/mailing/groups/:id',
    permission: 'mailing.view',
    access: 'authenticated',
    roles: ['ADMIN', 'LABO'],
    Component: GroupDetailsPage,
  },
];
